import { InputText } from "primereact/inputtext";
import './styles/input_text_style.css';

const InputTextComponent = ({className = '', children, ...props}) => {
    return (
        <InputText className={"text-input border-round-md py-2 px-3 fix-input-webkit-color " + className} {...props} />
    );
};

export default InputTextComponent;